import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import { CardController } from 'src/app/shared/card.controller';
import { PolicyRuleDataService } from '../policy-rule-form.data';
import { PolicyRuleListView } from './policy-rule-list.view';
import { ZuluIcon } from 'src/app/shared/icon';

interface PolicyRuleControllerProps {
	dataService: PolicyRuleDataService;
	policyRuleOwner: PolicyRuleOwner;
	mode: ControlMode;
	sections: string[];
	goToCard: (text: any, key: string, model: PolicyRuleItem) => void;
	setBusy: (isBusy: boolean) => void;
}

@observer
export class PolicyRuleListController extends React.Component<PolicyRuleControllerProps, {}> {
	@autobind
	private async handleCreateRule(): Promise<void> {
		const { dataService, policyRuleOwner } = this.props;
		const item = await dataService.add(policyRuleOwner);

		this.handleEditRule(item);
	}

	@autobind
	private handleEditRule(item: PolicyRuleItem): void {
		const { goToCard } = this.props;
		const textView = (
			<React.Fragment>
				<span>Policy Rule</span>
				<ZuluIcon type='close' />
				<br></br>
				<span>{item.id}</span>
			</React.Fragment>
		);

		goToCard(textView, 'rule', item);
	}

	render(): React.ReactNode {
		const { dataService, mode, sections, setBusy } = this.props;
		if (dataService == null || dataService.items == null) {
			return null;
		}

		return (
			<CardController
				icon="setting"
				className="card-borderless"
				title="Rules"
				mode={mode}>
				<PolicyRuleListView
					model={dataService}
					onCreateRule={this.handleCreateRule}
					onEditRule={this.handleEditRule}
					mode={mode}
					sections={sections}
					setBusy={setBusy}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/policy-rules/list/policy-rule-list.controller.tsx